import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../abstraction/auth.service';
import { IDcaRulesDto } from '../../../models/Dca';
import { Observable } from 'rxjs';
import { Utils } from '../../../utils/Utils';

@Component({
  selector: 'app-my-automations',
  templateUrl: './my-automations.component.html',
  styleUrls: ['./my-automations.component.scss'],
})
export class MyAutomationsComponent implements OnInit, OnDestroy {
  data: Observable<IDcaRulesDto>;
  isMobile: boolean;
  openCollapse: boolean;
  statusMenuMobile: boolean;
  update: number = 0;
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.data = this.authService.dcaRules;
    this.isMobile = Utils.onMobile();
  }

  ngOnDestroy() {
    this.authService.defaultCollapse();
  }

  updateRules(event) {
    if (event) {
      this.update++;
      if (this.update === 1) {
        this.authService.getDcaRules();
        setTimeout(() => {
          this.update = 0;
        }, 5000);
      }
    }
  }
}
